export var PENDING = 0;
export var SUCCESS = 1;
export var FAILURE = 2;